import React, { useMemo } from 'react';
import { Card, Row, Col, Form, Button } from 'react-bootstrap';
import { FaSearch, FaEraser } from 'react-icons/fa';
import Select from 'react-select';
import { customStyles, DropdownIndicator } from '~/Styles/reactSelectStyles';

const opcoesFiltroTriBool = [
  { value: 'todos', label: 'Todos' },
  { value: 'com', label: 'Com' },
  { value: 'sem', label: 'Sem' },
];

const FiltrosCard = ({
  gruposEmpresa,
  familias,
  contas,
  inputConta,
  onInputContaChange,
  valores,
  loading,
  onChange,
  onPesquisar,
  onLimpar,
  onBuscarConta,
}) => {
  const opcoesGE = useMemo(
    () =>
      (gruposEmpresa || []).map((ge) => ({
        value: ge.codigo_grupo_empresa,
        label: `${ge.codigo_grupo_empresa} - ${ge.nome}`,
      })),
    [gruposEmpresa]
  );

  const opcoesFamilias = useMemo(
    () =>
      (familias || []).map((f) => ({
        value: f.codigo_familia,
        label: f.nome_da_familia,
      })),
    [familias]
  );

  const opcoesContas = useMemo(
    () =>
      (contas || []).map((c) => ({
        value: c.codigo_conta,
        label: `${c.codigo_conta} - ${c.nome || ''}`,
      })),
    [contas]
  );

  const valorGE = opcoesGE.find((o) => o.value === valores.codigo_grupo_empresa) || null;
  const valorFamilia = opcoesFamilias.find((o) => o.value === valores.codigo_familia) || null;
  const valorConta = opcoesContas.find((o) => o.value === valores.codigo_conta) || null;

  const handleSelect = (campo) => (opcao) => {
    onChange(campo, opcao ? opcao.value : null);
  };

  const handleData = (campo) => (e) => {
    onChange(campo, e.target.value || null);
  };

  const handleRadio = (campo, valor) => () => {
    onChange(campo, valor);
  };

  return (
    <Card className="shadow-sm mb-3">
      <Card.Body className="py-3">
        <Row className="align-items-end">
          <Col md={3} className="mb-2">
            <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
              Grupo de Empresa <span className="text-danger">*</span>
            </Form.Label>
            <Select
              placeholder="Selecione..."
              options={opcoesGE}
              value={valorGE}
              onChange={handleSelect('codigo_grupo_empresa')}
              isClearable
              components={{ DropdownIndicator }}
              styles={customStyles}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
              Cliente específico
            </Form.Label>
            <Select
              placeholder={valores.codigo_grupo_empresa ? 'Buscar conta...' : 'Selecione um GE'}
              options={opcoesContas}
              value={valorConta}
              inputValue={inputConta}
              onChange={(opcao) => {
                onChange('codigo_conta', opcao ? opcao.value : null);
                onInputContaChange('');
              }}
              onInputChange={(valor, meta) => {
                if (meta && (meta.action === 'input-change' || meta.action === 'set-value')) {
                  onInputContaChange(valor);
                  onBuscarConta(valor);
                }
              }}
              isClearable
              isDisabled={!valores.codigo_grupo_empresa}
              components={{ DropdownIndicator }}
              styles={customStyles}
              filterOption={null}
              noOptionsMessage={() => 'Digite código ou nome'}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
              Empreendimento
            </Form.Label>
            <Select
              placeholder={valores.codigo_grupo_empresa ? 'Todos' : 'Selecione um GE'}
              options={opcoesFamilias}
              value={valorFamilia}
              onChange={handleSelect('codigo_familia')}
              isClearable
              isDisabled={!valores.codigo_grupo_empresa}
              components={{ DropdownIndicator }}
              styles={customStyles}
            />
          </Col>
        </Row>

        <Row className="align-items-end mt-2">
          <Col md={3} className="mb-2">
            <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
              Data início (quitação)
            </Form.Label>
            <Form.Control
              type="date"
              value={valores.data_inicio || ''}
              onChange={handleData('data_inicio')}
              style={{ height: '42px' }}
            />
          </Col>
          <Col md={3} className="mb-2">
            <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
              Data fim (quitação)
            </Form.Label>
            <Form.Control
              type="date"
              value={valores.data_fim || ''}
              onChange={handleData('data_fim')}
              style={{ height: '42px' }}
            />
          </Col>
          <Col md={6} className="mb-2 d-flex justify-content-end" style={{ gap: '8px' }}>
            <Button
              variant="outline-secondary"
              onClick={onLimpar}
              disabled={loading}
              style={{ height: '38px', whiteSpace: 'nowrap' }}
            >
              <FaEraser className="mr-1" /> Limpar
            </Button>
            <Button
              variant="primary"
              onClick={onPesquisar}
              disabled={loading}
              style={{ height: '38px', whiteSpace: 'nowrap' }}
            >
              <FaSearch className="mr-1" /> Pesquisar
            </Button>
          </Col>
        </Row>

        <Row className="mt-2">
          <Col md={6} className="mb-2">
            <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
              Escritura
            </Form.Label>
            <div className="d-flex" style={{ gap: '16px' }}>
              {opcoesFiltroTriBool.map((opt) => (
                <Form.Check
                  key={`escritura-${opt.value}`}
                  type="radio"
                  id={`filtro-escritura-${opt.value}`}
                  label={opt.label}
                  name="filtro_escritura"
                  value={opt.value}
                  checked={valores.filtro_escritura === opt.value}
                  onChange={handleRadio('filtro_escritura', opt.value)}
                  inline
                />
              ))}
            </div>
          </Col>
          <Col md={6} className="mb-2">
            <Form.Label className="mb-1" style={{ fontSize: '0.85rem', fontWeight: 600 }}>
              Emissão prévia
            </Form.Label>
            <div className="d-flex" style={{ gap: '16px' }}>
              {opcoesFiltroTriBool.map((opt) => (
                <Form.Check
                  key={`emissao-${opt.value}`}
                  type="radio"
                  id={`filtro-emissao-${opt.value}`}
                  label={opt.label}
                  name="filtro_emissao"
                  value={opt.value}
                  checked={valores.filtro_emissao === opt.value}
                  onChange={handleRadio('filtro_emissao', opt.value)}
                  inline
                />
              ))}
            </div>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default FiltrosCard;
